import React, { useState } from "react";
import bgImage from "../../Assets/business/banner.webp";

import novviBanner from "../../Assets/business/novvi.webp";
import lhBanner from "../../Assets/business/luxury-homes.webp";
import conciergeBanner from "../../Assets/business/concierge.webp";
import laundryBanner from "../../Assets/business/laundry.webp";
import maintenanceBanner from "../../Assets/business/maintenance.webp";
import cleanBanner from "../../Assets/business/cleanit.webp";

import novviLogo from "../../Assets/business/novvi-logo.png";
import lhLogo from "../../Assets/business/LH-logo.png";
import conciergeLogo from "../../Assets/business/concierge-logo.png";
import laundryLogo from "../../Assets/business/laundry-logo.png";
import maintenanceLogo from "../../Assets/business/maintenance-logo.png";
import cleansLogo from "../../Assets/business/cleans-logo.png";
import { Link } from "react-router-dom";

// SVG for Plus icon (When Closed)
const PlusIcon = ({ className = "w-6 h-6" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

// SVG for Minus icon (When Open)
const MinusIcon = ({ className = "w-6 h-6" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

const AccordionItem = ({
  title,
  content,
  websiteUrl,
  imageUrl,
  logo,
  index,
  initialOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const handleMouseEnter = () => {
    setIsOpen(true);
  };

  // Close when mouse leaves
  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  return (
    <div
      className="w-full mx-auto space-y-6 transition-all duration-500 ease-in-out"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        className={`flex justify-between bg-white items-center p-6 cursor-pointer select-none custom-shadow  rounded-t-md rounded-md overflow-hidden`}
      >
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-700">
          {title}
        </h2>
        <button
          className="p-1 text-gray-500 hover:text-gray-900 transition-colors duration-200"
          aria-expanded={isOpen}
          aria-controls="accordion-content"
        >
          {isOpen ? <MinusIcon /> : <PlusIcon />}
        </button>
      </div>

      <div
        id="accordion-content"
        className={`transition-all shadow-2xl custom-shadow rounded-md duration-1000 ease-in-out ${
          isOpen
            ? "md:max-h-[800px] max-h-[1200px] opacity-100 custom_margin-bottom"
            : "max-h-0 opacity-0"
        } overflow-hidden `}
      >
        <div className="p-0 ">
          <div className="flex flex-col md:flex-row">
            <div className="md:w-1/2 p-0">
              <img
                src={imageUrl}
                alt={`${title} view`}
                className="w-full h-full object-cover rounded-md shadow-md"
                // Placeholder image for the Dubai skyline/golf theme
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://placehold.co/600x400/296D3A/ffffff?text=Luxury+View";
                }}
              />
            </div>

            <div className="md:w-1/2 md:p-12 p-5 flex flex-col justify-between">
              <div className="h-full flex flex-col md:gap-10 gap-4 items-start justify-center">
                <img
                  src={logo}
                  alt={`${title} Logo`}
                  className={`md:w-44 w-36 object-contain ${
                    index === 1 && "md:w-48 w-52"
                  } ${index === 2 && "md:w-60 w-60"} ${
                    index === 4 && "md:w-52 w-52"
                  }`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://placehold.co/600x400/296D3A/ffffff?text=Luxury+View";
                  }}
                />
                <p className="text-gray-600 leading-relaxed text-sm">
                  {content}
                </p>

                <button className="px-5 py-2.5 text-sm font-medium bg-[#a9a7a3] text-white rounded-lg hover:bg-[#a9a7a3] transition duration-150 shadow-sm">
                  <a
                    href={`https://${websiteUrl}`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-inherit hover:text-inherit focus:text-inherit active:text-inherit"
                  >
                    Know more
                  </a>
                </button>
              </div>

              <p className="text-xs text-right text-gray-400 mt-4 md:block hidden">
                {websiteUrl}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const data = [
  {
    title: "NOVVI Properties",
    image: novviBanner,
    logo: novviLogo,
    description:
      "Discover the NOVVI Difference with NOVVI. Your home should feel like an extension of who you are, and we’re here to make that vision real. From your first viewing to the final handover, our team is by your side with insight, care, and dedication. We offer complete, full real estate solutions built around trust and transparency. In a city where many chase numbers, we choose people, building genuine connections and delivering service that goes beyond expectations. With NOVVI, finding your home isn’t a transaction, it’s the start of something lasting.",
    url: "www.novviproperties.com",
  },
  {
    title: "365 Luxury Homes",
    image: lhBanner,
    logo: lhLogo,
    description:
      "At 365 Luxury Homes, we turn imagination into experience. Whether you dream of waking up to ocean views on the Palm or living in the vibrant heart of Downtown Dubai, we’ll make it happen. Our curated collection of premium holiday homes blends style, comfort, and sophistication, transforming what it means to stay in Dubai. From short getaways to extended escapes, we tailor every detail to your lifestyle. With our bespoke concierge service, your stay goes beyond accommodation, it becomes a seamless journey of luxury, ease, and unforgettable moments.",
    url: "www.365luxuryhomes.com",
  },
  {
    title: "365 Luxury Concierge",
    image: conciergeBanner,
    logo: conciergeLogo,
    description:
      "Experience hospitality that feels personal, effortless, and entirely yours. Our luxury concierge is designed to bring the comfort of home and the indulgence of a five-star stay together under one roof. Each of our designer villas and hand picked properties are carefully prepared by our team to meet the highest standards of quality and style. From private chefs and curated shopping experiences to tours, transfers, and local insider tips, we take care of every detail. With 365 Luxury Homes, you don’t just stay in Dubai, you live it, beautifully.",
    url: "www.365luxuryconcierge.com",
  },
  {
    title: "365 Laundry",
    image: laundryBanner,
    logo: laundryLogo,
    description:
      " We proudly serve both residential communities and short-term rental properties, delivering reliable and high quality laundry solutions tailored to every need. From the supply and care of premium bed linen, towels, and table linen to professional garment laundering and dry cleaning, our services ensure comfort and consistency. Using cutting edge technology, we maintain the highest standards of hygiene, efficiency, and sustainability, all at a cost effective level. Whatever your requirements, we provide a complete, seamless solution built on trust, precision, and excellence.",
    url: "www.365laundry.ae",
  },
  {
    title: "365 Maintenance",
    image: maintenanceBanner,
    logo: maintenanceLogo,
    description:
      " We provide professional maintenance solutions for residential communities and homes, ensuring every space is safe, comfortable, and fully functional. From general repairs and AC servicing to plumbing, electrical work, and other household needs, our skilled team handles it all with efficiency and care. Using the latest tools and technology, we deliver reliable, high quality results at a cost-effective level. Whether it’s routine upkeep or urgent repairs, we offer comprehensive, flexible solutions to keep your home running smoothly and hassle-free.",
    url: "www.365maintenance.ae",
  },
  {
    title: "365 Cleans It",
    image: cleanBanner,
    logo: cleansLogo,
    description:
      " At 365 Cleans It, we deliver professional cleaning solutions you can rely on. With years of industry experience, we’ve earned a reputation for quality, efficiency, and affordability, ensuring every space is spotless, safe, and welcoming. Using modern equipment and eco-friendly cleaning products, our services cover everything from routine domestic cleaning, dusting, vacuuming, and mopping, to thorough kitchen and bathroom sanitisation. Safety and hygiene are at the heart of what we do, so you can enjoy a clean environment with complete peace of mind.",
    url: "www.365maintenance.ae",
  },
];
const Businesses = () => {
  return (
    <>
      <section
        className="brands_banner relative  py-12"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "30%",
        }}
      >
        <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-t from-black/90 to-black/20"></div>
        <div className="container h-full flex items-end justify-center relative z-10">
          <h1 className="text-center md:text-5xl md:leading-normal font-bold text-xl text-white md:mb-20 mb-14">
            Step Into Our World Where
            <br /> Every Experience Is Extraordinary
          </h1>
        </div>
      </section>
      <section className="-mt-16 relative z-10 pb-20">
        <div className="container">
          {data?.map((item, index) => (
            <AccordionItem
              title={item?.title}
              content={item?.description}
              websiteUrl={item?.url}
              imageUrl={item?.image}
              logo={item?.logo}
              index={index}
              initialOpen={index === 0 && true}
            />
          ))}
        </div>
      </section>
    </>
  );
};

export default Businesses;
